import * as React from 'react';
import '@roo/roo/theme/default/index.css';
import '@roo/roo-plus/theme/default/index.css';
import './App.scss';
import Router from './router';

function App() {
    return <Router />;
}

export default App;
